const autoNgTemplateLoaderTemplate1 = require('./disks-panel.html');

angular.module('portainer.docker').component('disksPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    disks: '<',
  },
});
